<template>
    <div>
        <div class="h5 font-bold mb-2.5 pad:px-4 md:px-0">
            線上保單服務交易應注意事項
        </div>
        <ol class="h5 list-decimal ml-6 pb-12 pad:px-4 md:px-0">
            <li
                v-for="item in terms"
                :key="item"
                class="mb-[0.3125rem]"
            >
                {{ item }}
            </li>
        </ol>
    </div>
</template>

<script>
import { ref } from 'vue';

const termsText = [
    '為確保交易安全性，若您使用無線網路上網時，建議您不要使用本公司線上保單服務。',
    '非必要時，建議您不要透過公眾電腦使用本公司線上保單服務。',
    '若您使用本公司線上保單服務，請先確認本公司網路正確之網址如有疑問，請洽詢本公司客戶服務專線：0809-000-550。',
    '您設定之密碼不應與個人顯性資訊（如：生日、身分證號碼、車號、電話號碼、匯款帳號及相關資料號碼）相同。',
    '提醒您，無論在任何時候，必須對本公司網路登錄之相關資料及密碼負保密義務，請不要將密碼告知任何人包括任何自稱為本公司人員或授權人士，且不要將此等資訊以電子郵件或其他類似之電子傳送方式（包括以通訊軟體，如：Skype、LINE）進行傳送；不宜將相同之密碼用作使用其他服務（包括參加網路會員之登錄密碼或於其他網站使用）。',
    '請您不要在使用本公司線上保單服務時離開電腦。',
    '請您於完成交易操作後，立即登出本公司線上服務。',
    '您於接獲本公司線上保單服務交易完成確認通知後，請儘速檢核是否正確。如發現或懷疑帳號、密碼未經授權而被他人使用時，請立即以電話或其他約定之方式通知本公司。',
];

export default {
    name: 'TermsHome',
    setup() {
        const terms = ref(termsText);
        return {
            terms
        };
    }
};
</script>
